import BaseResource from '@sigmacloud/sigma-client/dist/resources'

export default class AccountGroup extends BaseResource {
  static endpoint = '/accountgroup'
  static modelName = 'AccountGroup'
}
